if (!customElements.get('discount-code')) {
  class DiscountCode extends HTMLElement {
    constructor() {
      super();
      this.discountCode = this.querySelector('.js-discount-code');
      this.discountCodeBtn = this.querySelector('.js-copy-button');
      this.copySuccess = this.querySelector('.js-copy-success');
      this.copySuccessText = this.querySelector('.js-copy-success-text');
      this.copyFeedbackTimeouts = [];
      this.init();
    }

    clearCopyFeedbackTimers() {
      this.copyFeedbackTimeouts.forEach((id) => clearTimeout(id));
      this.copyFeedbackTimeouts = [];
    }

    init() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        this.discountCodeBtn.addEventListener('click', this.copyCode.bind(this));
        this.discountCode.addEventListener('click', this.copyCode.bind(this));
      } else {
        this.discountCodeBtn.hidden = true;
      }
    }

    copyCode() {
      const discountCode = this.discountCode.textContent.trim();
      const successMessage = theme.strings.discountCopySuccess || 'Copied';

      navigator.clipboard.writeText(discountCode).then(
        () => {
          this.clearCopyFeedbackTimers();
          this.copySuccess.classList.remove('is-closing');
          if (this.copySuccessText) {
            this.copySuccessText.textContent = '';
            requestAnimationFrame(() => {
              if (this.copySuccessText) {
                this.copySuccessText.textContent = successMessage;
              }
            });
          }
          this.copySuccess.classList.add('is-visible');

          this.copyFeedbackTimeouts.push(
            setTimeout(() => {
              this.copySuccess.classList.add('is-closing');
              this.copyFeedbackTimeouts.push(
                setTimeout(() => {
                  this.copySuccess.classList.remove('is-closing', 'is-visible');
                  if (this.copySuccessText) {
                    this.copySuccessText.textContent = '';
                  }
                  this.clearCopyFeedbackTimers();
                }, 300)
              );
            }, 5000)
          );
        },
        () => {
          alert(theme.strings.discountCopyFail); // eslint-disable-line
        }
      );
    }
  }

  customElements.define('discount-code', DiscountCode);
}
